export default __webpack_public_path__ + "static/media/8.ee1de961.png";